module.exports = __webpack_public_path__ + "img/图层 77.d73b6e7d.png";